import React, { useState, useEffect, useRef } from "react";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import axios from "axios";
import SelectBox from "../components/select-box";
import DemoDataGrid from "../components/data-grid";
import Dropdown from "../components/drop-down";
import DashboardHeader from "../components/dashboard-header";
import {
    createChart,
    CrosshairMode,
    LineStyle,
    PriceLineSource,
  } from "lightweight-charts";


import {
  defualtErrorMessage,
  graphColorList,
} from "../common/common-variables";
import {
  getTickers,
  searchTickers,
  getMacroSecondaryMetrics,
  getMacroOhlcData,
} from "../apis/analysis-apis";

// const defaltPrimaryMetric = [
//   {
//     label: "Apple Inc - AAPL - Common Stock - NASDAQ - USA",
//     value: "Apple Inc - AAPL - Common Stock - NASDAQ - USA",
//   },
// ];

const defaltSecondaryMetric = [
  // {
  //   label: "Producer Price Index by Industry: Deep Sea Freight Transportation",
  //   value: "Producer Price Index by Industry: Deep Sea Freight Transportation",
  // },
];


export default function chartDemo( ) {

  const [clickedCellValue, setClickedCellValue] = useState(null);
  const [dashboardTitle, setDashboardTitle] = useState("Correlation Dashboard");
  
  
  const [secondaryMetricOptions, setSecondaryMetricOptions] = useState([]);
  const [selectSecondayMetrics, setSelectSecondayMetrics] = useState(
    defaltSecondaryMetric
  );
  const [showGraph, setShowGraph] = useState(false);
  const [graphDate, setGraphDate] = useState({
    startDate: "2015-01-01",
    endDate: "2024-01-01",
  });

  const [showLoader, setShowLoader] = useState(true);
  const [primayScale, setPrimaryScale] = useState({
    label: "Regular",
    value: "primary_linear",
    title: "Series values.",
  });
  const [secondaryScale, setSecondaryScale] = useState({
    label: "Regular",
    value: "primary_linear",
    title: "Series values.",
  });
  
  const [primaryData, setPrimaryData] = useState([]);
  const [secondaryData, setSecondaryData] = useState([]);
  const [hoverdValuesLegends, setHoverdValuesLegends] = useState([]);
  const [dataGridValue, setDataGridValue]  = useState([])

  const chartContainerRef = useRef();
  const chart = useRef();
  const tooltipRef = useRef();

  

  const handleCellClick = (params) => {
   // console.log(clickedCellValue)
    const newSecondaryMetric=[{
        label: params.data.Code1_name,
        value: params.data.Code1_name,
      } ,
      {
        label: params.data.Code2_name,
        value: params.data.Code2_name,
      }]   
   //console.log('from the perent component',newSecondaryMetric)
   setShowGraph(true)
    setClickedCellValue(params.data.Code1_name);
    setSelectSecondayMetrics( newSecondaryMetric)

  };

  
  const handleChangeSecondaryMetric = (selectedOptions) => {
    
    //console.log("Length of ",selectedOptions)
    setSelectSecondayMetrics(selectedOptions);
    if (!selectedOptions?.length){
      
    }
  };
 

    // setting the secondary metrics options on dashbaord load.
    useEffect(() => {
      
      setShowLoader(true);
  
      //const primaryMetrics = selectPrimaryMetrics?.map((metric) => metric.value);
      const secondaryMetrics = selectSecondayMetrics?.map(
        (metric) => metric.value
      );
      const startDate = graphDate.startDate;
      const endDate = graphDate.endDate;
  
      const queryObject = {
        //primary_metrics: primaryMetrics,
        secondary_metrics: secondaryMetrics,
        start_date: startDate,
        end_date: endDate,
      };
  
      getMacroOhlcData(queryObject)
        .then((resp) => {          
          setSecondaryData(JSON.parse(resp.data.secondary_data));
          
          
          // console.log("setting the show loader false");
          setShowLoader(false);
  
        })
        .catch((err) => {
          //console.log("this is the error", err)
        });
  
      const data = {
        key1: "value1",
        key2: "value2",
      };
    }, [ selectSecondayMetrics, graphDate]);
  
    useEffect(() => {
      //console.log("regenerating the chart agin", primaryData)
      chart.current = createChart(chartContainerRef.current, {
        width: chartContainerRef.current.clientWidth,
        height: chartContainerRef.current.clientHeight - 20, //'800', //"300px", //chartContainerRef.current.clientHeight,
        // chart color options:   https://tradingview.github.io/lightweight-charts/tutorials/customization/chart-colors
        layout: {
          backgroundColor: "#000",
          textColor: "rgba(255, 255, 255, 0.9)",
        },
        grid: {
          vertLines: {
            color: "#334158",
          },
          horzLines: {
            color: "#334158",
          },
        },
        crosshair: {
          mode: CrosshairMode.Normal,
        },
        priceScale: {
          borderColor: "#485c7b",
        },
        timeScale: {
          borderColor: "#485c7b",
        },
        watermark: {
          visible: true,
          fontSize: 40,
          horzAlign: "center",
          vertAlign: "center",
          color: " rgba(255, 165, 0, 0.1)",
          text: "Anahit",
        },
      });
  
      chart.current.subscribeClick(myClickHandler);

  
      // Setting the border color for the horizontal axis
      chart.current.timeScale("left").applyOptions({
        borderColor: "#71649C",
        visible: true,
      });
  
      chart.current.priceScale("left").applyOptions({
        // borderColor: '#71649C',
        visible: true,
      });
  
      ////console.log(chart.current);
  
      const candleSeries = chart.current.addCandlestickSeries({
        upColor: "#4bffb5",
        downColor: "#ff4976",
        borderDownColor: "#ff4976",
        borderUpColor: "#4bffb5",
        wickDownColor: "#838ca1",
        wickUpColor: "#838ca1",
      });
  
      candleSeries.applyOptions({
        priceScaleId: "left",
      });
      const volumeSeries = chart.current.addHistogramSeries({
        color: "green",
        lineWidth: 2,
        priceFormat: {
          type: "volume",
        },
        overlay: true,
        scaleMargins: {
          top: 0.8,
          bottom: 0,
        },
      });
  
      // volumeSeries.setData(volumeData);
  
      if (secondaryData?.length) {
        ////console.log("insdie primary count df", secondaryScale)
        const secondaryValueToBeShown =
          secondaryScale.value == "primary_linear"
            ? "value"
            : secondaryScale.value;
            setShowGraph(true);
        secondaryData.forEach(function (object, index) {
          const code = Object.keys(object)[0];
          //console.log("this are the seondary key ", code)
          const lineSeriesSecondary = chart.current.addLineSeries({
            color: graphColorList[index],
          }); //, priceScaleId: "left", lineStyle: LineStyle.Solid, lineWidth: 1, priceLineSource: PriceLineSource.LastVisible
          const secondaryParsedata = object[code]?.map((df) => ({
            time: df.date, // timestamp, Ex: 1698361200000
            value: df[secondaryValueToBeShown],
          }));
          lineSeriesSecondary.setData(secondaryParsedata);
        });
      } else {
        // lineSeriesPrimary.setData(lineData2);
      }
  
      
  
      ////console.log("primary data primaryData.count", primaryData.count)
      var lineSeriesPrimary = null;
      
  
      // to zoomin 100% on load
      chart.current.timeScale().fitContent();
  
      // Customizing the Crosshair
      // https://tradingview.github.io/lightweight-charts/tutorials/how_to/two-price-scales
      chart.current.applyOptions({
        crosshair: {
          // Change mode from default 'magnet' to 'normal'.
          // Allows the crosshair to move freely without snapping to datapoints
          // mode: CrosshairMode.Normal,
  
          // Vertical crosshair line (showing Date in Label)
          vertLine: {
            // width: 8,
            // color: '#C3BCDB44',
            // style: LineStyle.Solid,
            labelBackgroundColor: "#9B7DFF",
          },
  
          // Horizontal crosshair line (showing Price in Label)
          horzLine: {
            // color: '#9B7DFF',
            labelBackgroundColor: "#9B7DFF",
          },
          rightPriceScale: {
            visible: false,
          },
          leftPriceScale: {
            visible: true,
          },
        },
      });
  
      // gets triggered whenever the mouse hover overs graph
      chart.current.subscribeCrosshairMove((params) => {
        // console.log("params", params)
        if (params.time) {
          // console.log("params point", params.point)
          const hoverdValues = [];
          const tooltipLeft = params.point.x;
          const data = params.seriesPrices.get(lineSeriesPrimary);
          //const tooltipTop = lineSeriesPrimary.priceToCoordinate(data);
  
          //tooltipRef.current.style.left = tooltipLeft + "px";
          // tooltipRef.current.style.top = tooltipTop + 20 + "px"
  
          // console.log("this is the tooltipLeft", tooltipLeft)
          // console.log("this is the tooltipTop", tooltipTop)
  
          for (let [key, value] of params.seriesPrices.entries()) {
            //console.log(`key : ${key}, value :${value}`);
            // console.dir(`key dir : ${key}`);x
            hoverdValues.push(value);
            setHoverdValuesLegends(hoverdValues);
          }
        } else {
          setHoverdValuesLegends([]);
        }
      });

  
      const handleWindowResize = () => {
        // console.log(
        //   `reseting the graph width: ${chartContainerRef.current.clientWidth} height: ${chartContainerRef.current.clientHeight}`
        // );
        chart.current.applyOptions({
          width: chartContainerRef.current.clientWidth,
          height: chartContainerRef.current.clientHeight - 20,
        });
      };
  
      window.addEventListener("resize", handleWindowResize);
  
      return () => {
        chart.current.remove();
        window.removeEventListener("resize", handleWindowResize);
      };
    }, [
      primaryData,
      secondaryData,
      primayScale,
      secondaryScale
    ]);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);

    if (searchParams.size) {
      // setting the input fields according to the queryset parameters.

      const selectPrimaryMetrics = searchParams.has("primary_metric")
        ? JSON.parse(searchParams.get("primary_metric"))
        : selectPrimaryMetrics;
      const selectSecondayMetrics = searchParams.has("secondary_metric")
        ? JSON.parse(searchParams.get("secondary_metric"))
        : selectPrimaryMetrics;
      const startDate = searchParams.has("start_date")
        ? searchParams.get("start_date")
        : startDate;
      const endDate = searchParams.has("end_date")
        ? searchParams.get("end_date")
        : endDate;
      const primayScale = searchParams.has("primary_scale")
        ? JSON.parse(searchParams.get("primary_scale"))
        : primayScale;
      const secondaryScale = searchParams.has("secondary_scale")
        ? JSON.parse(searchParams.get("secondary_scale"))
        : secondaryScale;

      setSelectPrimaryMetrics(selectPrimaryMetrics);
      setSelectSecondayMetrics(selectSecondayMetrics);
      
    }

    const paramsObject = {
      dashboard_name: "producer_price_index_react_codes",
      dashboard_path: location.pathname,
    };

    getMacroSecondaryMetrics(paramsObject)
      .then((resp) => {
        const secondaryOptions = resp.data.data;
        setSecondaryMetricOptions(secondaryOptions);
        setDashboardTitle(resp.data.dashboard_title);
      })
      .catch((err) => {
        ////console.log("this is the error", err)
      });
  }, []);


  useEffect(() => {
    const paramsObject = {
      dashboard_name: "producer_price_index_react_codes",
      dashboard_path: location.pathname,
    };
    getMacroSecondaryMetrics(paramsObject)
      .then((resp) => {
        const secondaryOptions = resp.data.data;
        setSecondaryMetricOptions(secondaryOptions);
        setDashboardTitle(resp.data.dashboard_title);
      })
      .catch((err) => {
        //console.log("this is the error", err)
      });
  }, []);



    // setting the secondary metrics options on dashbaord load.
    useEffect(() => {
      // console.log("setting the show loader true");
      setShowLoader(true);
      
  
      //const primaryMetrics = selectPrimaryMetrics?.map((metric) => metric.value);
      const secondaryMetrics = selectSecondayMetrics?.map(
        (metric) => metric.value
      );
      
      const startDate = graphDate.startDate;
      const endDate = graphDate.endDate;
  
      const queryObject = {
        //primary_metrics: primaryMetrics,
        secondary_metrics: secondaryMetrics,
        start_date: startDate,
        end_date: endDate,
      };
  
      getMacroOhlcData(queryObject)
        .then((resp) => {
          // const df = new dfd.DataFrame(data);
          //setPrimaryData(JSON.parse(resp.data.primary_data));
          setSecondaryData(JSON.parse(resp.data.secondary_data));
          // console.log("setting the show loader false");
          setShowLoader(false);
  
          // df.head().print()
        })
        .catch((err) => {
          //console.log("this is the error", err)
        });
  
      const data = {
        key1: "value1",
        key2: "value2",
      };  
    }, [selectSecondayMetrics, graphDate]);


    function myClickHandler(param) {
      //console.log(`Click at ${param}`);
      //console.log(JSON.stringify(param, null, 2));
  
    }


    
  return (
          <>     
          <Grid
          container
          item
          spacing={2}
          sx={{
            p: 2,
            borderRadius: 2,
            bgcolor: "#000",
            display: "grid",
          }}
        >
          <DashboardHeader
            title={dashboardTitle}
           // handleClickBookmark={handleClickBookmark}
           // handleClickLike={handleClickLike}
           // isDashboardLiked={isDashboardLiked}
           // isDashboardBookmarked={isDashboardBookmarked}
           // handleClickBookmarkEdit={handleClickBookmarkEdit}
          />
        </Grid>
        <Grid
          container
          item
          spacing={2}
          sx={{
            p: 2,
            borderRadius: 2,
            bgcolor: "#000",
            display: "grid",
          }}
        >
          <Box>
              Correlated Series
            < DemoDataGrid onCellClick={handleCellClick}/>
            </Box>
        </Grid>
          <Grid item xs={12}>
          <Grid item xs={12}>
            
          </Grid>
            {/* <Grid item xs={12}>  
            <Box
              sx={{
                // p: 2,
                borderRadius: 2,
                bgcolor: "#000",
                // display: 'grid',
                // gridTemplateColumns: { md: '1fr 1fr' },
                // gap: 2,
              }}
              className="select-container"
            >
            </Box>
            
            </Grid> */}
            <br/>
            <Grid
          container
          item
          spacing={2}
          sx={{
            p: 2,
            borderRadius: 2,
            bgcolor: "#000",
            display: showGraph ? "grid" : "none",
          }}
        >
          {/* {showLoader && (
              <div className="loader-container">
                {" "}
                <PreLoader />{" "}
              </div>
          )}   */}
          <br/><br/>
            <Box
            id="chart-id"
            ref={chartContainerRef}
            className="chart-container"
            style={{ height: "65vh", position: "relative", 
            display: showGraph ? "block" : "none"
          }}
          ></Box>
         <Box sx={{ position: "relative", zIndex: "10", fontSize: "10px" }}></Box>
          <Box
                id="secondary-legend-div"
                sx={{ position: "absolute", left: "70px", fontSize: "11px" }}
              >
                {selectSecondayMetrics?.map((metric, index) => (
                  <Box key={metric.value}>
                    {metric.value}{" "}
                    {hoverdValuesLegends.length
                      ? `: ${hoverdValuesLegends[index]}`
                      : null}
                  </Box>
                ))}
              </Box>
          </Grid>
        </Grid>
    </>
  );
}

